import { render, staticRenderFns } from "./SignUpContainer.vue?vue&type=template&id=dd8e53bc&scoped=true"
import script from "./SignUpContainer.vue?vue&type=script&lang=js"
export * from "./SignUpContainer.vue?vue&type=script&lang=js"
import style0 from "./SignUpContainer.vue?vue&type=style&index=0&id=dd8e53bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd8e53bc",
  null
  
)

export default component.exports